// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vjthmlybhiphyoiipqjh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqdGhtbHliaGlwaHlvaWlwcWpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ4MDEzMTcsImV4cCI6MjA2MDM3NzMxN30.yk6mKYvwF7isMV-hGqTf5RWm4hp1NA9wW6NWywqQkFw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);